import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Stack, Typography } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
const HeaderSection = ({ title, subtitle, onExport, canExport }) => (
  <Stack
    direction={{ xs: "column", md: "row" }}
    alignItems={{ md: "center" }}
    justifyContent="space-between"
    gap={2}
    sx={{
      p: 3,
      color: "#fff",
      background: "linear-gradient(120deg,#1e293b,#0b4f6c)",
      borderRadius: "12px 12px 0 0",
    }}
  >
    <Stack direction="row" alignItems="center" gap={2}>
      <Box sx={{ p: 1.2, display: "flex", bgcolor: "#ffffff18", borderRadius: 2 }}>
        <AssessmentIcon />
      </Box>
      <Box>
        <Typography variant="h5" color="inherit" fontWeight={700}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "#d5e4ed", mt: 0.5 }}>
          {subtitle}
        </Typography>
      </Box>
    </Stack>
    <Button
      variant="contained"
      onClick={onExport}
      disabled={!canExport}
      startIcon={<FileDownloadIcon />}
      sx={{
        alignSelf: { xs: "flex-start", md: "center" },
        bgcolor: "#fff",
        color: "#16435b",
        "&:hover": { bgcolor: "#eaf3f7" },
        "&.Mui-disabled": { bgcolor: "#ffffff20", color: "#ffffff88" },
      }}
    >
      Exportar Excel
    </Button>
  </Stack>
);
HeaderSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onExport: PropTypes.func,
  canExport: PropTypes.bool,
};
HeaderSection.defaultProps = {
  title: "Gestión de conciliaciones",
  subtitle: "Consulta y cuadre de peajes por concesión",
  onExport: () => {},
  canExport: false,
};
export default HeaderSection;
